import Offcanvas from "react-bootstrap/Offcanvas";
import { LuLogOut, LuDownload } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function RightDrawer({ show, setShow }) {
  const handleClose = () => setShow(false);
  const navigate = useNavigate();

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        name={"end"}
        placement={"end"}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Settings</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="d-flex flex-column gap-4">
          
          {/* Download APK */}
          <div
            className="navItem d-flex gap-3 fs-5 justify-content-end align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/download");
              handleClose();
            }}
          >
            Download APK
            <LuDownload className="fs-1 textPrimary" />
          </div>

          {/* Logout */}
          <div
            className="navItem d-flex gap-3 fs-5 justify-content-end align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              localStorage.clear();

              setTimeout(() => {
                navigate("/login");
              }, 500);

              handleClose();
            }}
          >
            Log Out
            <LuLogOut className="fs-1 textPrimary" />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default RightDrawer;